var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-modal",
    {
      attrs: {
        "class-name": "profile-field-add-dictionary-modal",
        active: _vm.displayModal,
        title: _vm.title,
      },
      on: { close: _vm.close },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _c("c-button", {
                attrs: {
                  responsive: "",
                  label: "Сбросить",
                  icon: {
                    icon: "close",
                    color: "secondary",
                  },
                },
                on: { click: _vm.close },
              }),
              _c("c-button", {
                attrs: {
                  responsive: "",
                  label: "Применить",
                  icon: {
                    icon: "check",
                    color: "green",
                  },
                },
                on: { click: _vm.addVariants },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "form-group",
              class: {
                "is-invalid": _vm.isSubmitted && _vm.errorText,
              },
            },
            [
              _c("c-textarea", {
                staticClass: "form__field",
                attrs: {
                  placeholder: "Значения",
                  clearable: true,
                  error: _vm.isSubmitted && _vm.errorText,
                  invalid: _vm.isSubmitted && _vm.errorText,
                },
                model: {
                  value: _vm.variantsString,
                  callback: function ($$v) {
                    _vm.variantsString = $$v
                  },
                  expression: "variantsString",
                },
              }),
              !(_vm.isSubmitted && _vm.errorText)
                ? _c("div", { staticClass: "form-note" }, [
                    _vm._v("Введите варианты списка по одному в строке"),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }